<div class="form-row row">
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.shared.fields.firstname' | translate}}</label>
    <div>{{parker?.firstName ?? '-'}}</div>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.shared.fields.lastname' | translate}}</label>
    <div>{{parker?.lastName ?? '-'}}</div>
  </div>
</div>
<div class="form-row row">
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.shared.fields.email' | translate}}</label>
    <div>{{parker?.email ?? '-'}}</div>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.company' | translate}}</label>
    <div>{{companyName ?? '-'}}</div>
  </div>
</div>
<div class="form-row row">
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.title' | translate}}</label>
    <div>{{parker?.title ?? '-'}}</div>
  </div>
  <div class="form-group col-md-6">
    <label class="control-label">{{'i18n.shared.fields.phone' | translate}}</label>
    <div>{{parker?.phone ?? '-'}}</div>
  </div>
</div>
<div class="form-row row">
  <div class="form-group col-md-6 mb-0">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.identification' | translate}}</label>
    <div>{{parker?.identification ?? '-'}}</div>
  </div>
  <div class="form-group col-md-6 mb-0">
    <label class="control-label">{{'i18n.domain.parker-registration.fields.plate' | translate}}</label>
    <div class="text-uppercase">{{licenseNumber ?? '-'}}</div>
  </div>
</div>
